<template>
    <div class="biz">
        <div class="biz-header">
            <startup class="startup-wrapper" v-if="isIdle || isLoading"></startup>
            <fatal
                class="fatal-wrapper"
                @retry="retry"
                @close="close"
                v-else-if="isError"
                :message="error && error.message"
                :code="error && error.code"
            ></fatal>
            <router-view v-else></router-view>
            <!-- 上面的startup其实用来控制载入页面的loading，下面的startup是用来控制页面内提交操作的loading -->
            <startup
                class="loading"
                v-show="isSubmitting"
                @click.prevent
                @touch.prevent
            ></startup>
        </div>
        <div class="biz-footer" v-if="!inYoda">
            <div class="ks-logo"></div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import '../assets/style/flex.less';
.biz {
    .f();
    .f-d-c();
    min-height: 100%;
}
.biz-header {
    .f();
    .f-d-c();
    .f-1()
}
.biz-footer {
    padding-top: 40px;
    padding-bottom: 24px;
    .ks-logo {
        margin: 0 auto;
        width: 59px;
        height: 22px;
        background: var(--csc-collect-ks-logo) no-repeat;
        background-size: contain;
    }
}
.fatal-wrapper {
    .f-1();
}
.startup-wrapper {
    .f-1();
}
.loading {
    position: fixed;
    z-index: 100;
    background: rgba(255, 255, 255, 0.5);
    top: 0;
    width: 100vw;
    height: 100vh;
}
</style>

<script>
import { createNamespacedHelpers, mapActions, mapState } from 'vuex';
import Startup from '@/components/Startup.vue';
import Fatal from '@/components/Fatal.vue';
import { exitWebView } from '@/utils/bridge';
import { inYoda } from '@/utils/device';

const {
    mapGetters: mapStartupGetters,
    mapState: mapStartupState,
} = createNamespacedHelpers('startup');
export default {
    name: 'biz',
    components: {
        Startup,
        Fatal,
    },
    data() {
        return {
            inYoda,
        };
    },
    props: {
        bizKey: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapStartupState(['error']),
        ...mapStartupGetters(['isIdle', 'isLoading', 'isError', 'isComplete']),
        ...mapState(['isSubmitting']),
    },
    methods: {
        ...mapActions(['bootstrap']),
        retry() {
            location.reload();
        },
        close() {
            exitWebView();
        },
    },
    watch: {
        bizKey() {
            this.bootstrap();
        },
    },
    mounted() {
        this.bootstrap();
    },
};
</script>
